export default {
  'data-private': true
}
